import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { Journal } from '@/models/accounting/Journal'

export default new CachedResourceStore<Journal>(Journal, {
	namespaced: true
})
